import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Button } from "reactstrap";
import SelectSearchBox from "../../common/SelectBoxSearch";
import TableWithSortPagtn from "../../common/TableWithSortPagtn";

const EmployeeAssets = (props) => {
  const { empList, assets } = props;
  // const [assetsArr, setAssetsArr] = useState(props.assets);
  const [selectedUserForAssets, setSelectedUserForAssets] = useState("");
  const [trow, setTrow] = useState([]);
  const [thead, setThead] = useState([]);
const [selectedEmployee, setSelectedEmployee] = useState(null);
  //   Functiions ------------------
  const selectedUserFromSearch = (emp) => {
    setSelectedEmployee(emp); 
    let trowArr = empList
      .filter((ele) => ele.label === emp.label)
      .map((ele, i) => {
        return {
          "#": i + 1,
          "Employee Name": ele.label,
          Action: <span onClick={() => handleTrowClick(ele)}>View Assets</span>,
        };
      });
    setTrow(trowArr);
  };

  // from TableWithSorPagtn.js, ie clicked on the row of user view more.
  const handleTrowClick = React.useCallback(
    (emp) => {

      setSelectedUserForAssets(emp.label);
      let thead = ["#", "Item Name", "Item No", "Item Model"];
      let arr = [];
      // props.assets.map((asset, i) => {
      //   return asset.assetItems
      //     .filter((ele) => {
      //       return ele.user === emp.label;
      //     })
      //     .map((el, k) => {
      //       return arr.push({
      //         "#": i + 1,
      //         "item name": el.itemDescription,
      //         "item no": el.itemNo,
      //         "item model": el.modelNo,
      //       });
      //     });
      // });
      assets
        .filter((ele) => ele.employeeId === emp.value.employeeId)
        .map((el, k) => {
          return arr.push({
            "#": k + 1,
            "Item Name": el.itemModel,
            "Item No": el.itemNo,
            "Item Model": el.modelNo,
          });
        });
      setThead(thead);
      setTrow(arr);
    },
    [assets]
  );

  useEffect(() => {
    tableValues();
  }, [empList]);

  const tableValues = React.useCallback(() => {
    setSelectedEmployee(null);
    let thead = ["#", "Employee Name", "Action"];

    let trowArr = empList.map((ele, i) => {
      return {
        "#": i + 1,
        "Employee Name": ele.label,
        Action: <span onClick={() => handleTrowClick(ele)}>View Assets</span>,
      };
    });
    setThead(thead);
    setTrow(trowArr);
  }, [empList, handleTrowClick,setSelectedEmployee]);

  return (
    <Fragment>
      <Row className="mt-2 ">
        <Col xs={12} sm={8} md={8}>
          {selectedUserForAssets ? (
            <Fragment>
              {" "}
              <Button
                color=""
                className="btn-admin-settings "
                onClick={() => {
                  tableValues();
                  setSelectedUserForAssets("");
                  setSelectedEmployee(null);
                  // setIsOpenGridView(true);
                  // setIsOpenAssetItems(false);
                  // setSelectedAsset(""); // on back set the selected data empty
                }}
              >
                <i className="fas fa-arrow-left  "></i> <strong>|</strong>&nbsp;
                <span className="text-dark">
                  Employee :{selectedUserForAssets}
                </span>
              </Button>
            </Fragment>
          ) : (
            ""
          )}
        </Col>
        <Col xs={12} sm={4} md={4}>
          <SelectSearchBox
            options={empList}
            selectedUser={selectedEmployee}
            value={selectedEmployee}
            placeholder="Select Employee"
            isClearable
            onChange={(user) => selectedUserFromSearch(user)}
          ></SelectSearchBox>
        </Col>
      </Row>
     <br/>

      <TableWithSortPagtn thead={thead} trow={trow} pageSize={5}></TableWithSortPagtn>
    </Fragment>
  );
};

export default EmployeeAssets;
